(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-posts"] && !Shopify.designMode) return;
  try {
    
  /**
   * Instagram's embed.js is ~30KB of third-party script from a third-party
   * origin. Loading it eagerly on the homepage would cost every visitor that
   * request whether or not they ever scroll this far, on a store whose slowest
   * page is already an open question. So it loads on intersection, once.
   *
   * Everything here is defensive on purpose: this is the one component on the
   * site whose behaviour depends on a script we do not control and cannot fix.
   * If it never arrives, the blockquote fallback links stay on the page and the
   * section still works, just plainer.
   */
  (() => {
    const SRC = 'https://www.instagram.com/embed.js';
    let loading = null;

    function loadEmbedScript() {
      if (loading) return loading;
      if (window.instgrm?.Embeds) return (loading = Promise.resolve());

      loading = new Promise((resolve) => {
        const existing = document.querySelector(`script[src="${SRC}"]`);
        if (existing) {
          existing.addEventListener('load', () => resolve(), { once: true });
          // A script tag already in the DOM may have ALREADY loaded, in which
          // case no further load event ever fires and we would wait forever.
          existing.addEventListener('error', () => resolve(), { once: true });
          if (window.instgrm?.Embeds) resolve();
          // An already-settled tag fires NEITHER event again. Without this the
          // promise never settles and, since it is cached, the section can never
          // retry for the rest of the visit. Found by two independent reviews.
          setTimeout(resolve, 3000);
          return;
        }
        const s = document.createElement('script');
        s.src = SRC;
        s.async = true;
        // Resolve on error too. A rejected promise here would leave the section
        // in a permanent "loading" state; resolving lets process() no-op and the
        // fallback links remain, which is the graceful outcome.
        s.addEventListener('load', () => resolve(), { once: true });
        s.addEventListener('error', () => resolve(), { once: true });
        document.head.appendChild(s);
      });
      return loading;
    }

    function process() {
      // Instagram exposes process() only after the script has initialised, and
      // it is safe to call repeatedly — it skips blockquotes it has already
      // converted. Guarded because a blocked script leaves window.instgrm unset.
      try {
        window.instgrm?.Embeds?.process?.();
      } catch (e) {
        /* A third-party failure must not take the page's other scripts with it. */
      }
    }

    function hydrate(root) {
      const section = root || document;
      if (!section.querySelector?.('.dm-ig-embed')) return;
      loadEmbedScript().then(process);
    }

    function observe(root) {
      // querySelectorAll, not querySelector. A section file's {% javascript %} is
      // bundled ONCE per page rather than once per instance, so with two copies
      // of this section the single-element form watched only the first — and a
      // visitor landing deep-linked next to the second would never load embed.js.
      const els = [...((root || document).querySelectorAll?.('.dm-ig-section') || [])];
      if (!els.length) return;

      if (!('IntersectionObserver' in window)) {
        hydrate(root);
        return;
      }
      const io = new IntersectionObserver(
        (entries, obs) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            obs.disconnect();
            hydrate(root);
          }
        },
        // Start fetching a little before it scrolls in, so the embeds are
        // usually painted by the time the section is actually on screen.
        { rootMargin: '400px 0px' }
      );
      for (const el of els) io.observe(el);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => observe(document), { once: true });
    } else {
      observe(document);
    }

    // The theme editor re-renders a section in place when a setting changes. The
    // new blockquotes are unprocessed markup, so without this a merchant editing
    // this block watches every embed turn back into plain text and stay there.
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector?.('.dm-ig-section')) observe(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["military-first-responder"] && !Shopify.designMode) return;
  try {
    
  /* Move focus to the banner after a post. The form reloads the page, so without
     this the only feedback is a paragraph appearing off-screen. Same behaviour as
     the fleet form; kept here rather than shared because the two sections are
     deliberately independent of one another. */
  document.querySelectorAll('[data-mfr-focus]').forEach((el) => {
    el.focus({ preventScroll: false });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["platform-categories"]) return;
  try {
    
  /*
   * Staggered entrance. Deliberately additive: the hiding attribute is set by
   * this script, so if it never runs - old browser, an error upstream, blocked
   * scripts - the cards render in their normal visible state instead of being
   * stuck at opacity 0. A decorative animation must never be able to hide the
   * content it decorates.
   */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('.platform-cats__grid').forEach(function (grid) {
      var items = Array.prototype.slice.call(grid.children);
      items.forEach(function (el, i) {
        el.setAttribute('data-pc-reveal', '');
        el.style.setProperty('--pc-delay', Math.min(i * 65, 420) + 'ms');
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      items.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  /* Delegated, so it survives a section re-render in the theme editor and needs
     no per-instance wiring. Liquid is NOT interpolated into this file by Shopify,
     so every value it needs is read from a data attribute. */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.dm-pv__play');
    if (!button) return;
    const id = button.getAttribute('data-dm-yt');
    if (!id) return;

    const frame = document.createElement('iframe');
    const params = new URLSearchParams({ autoplay: '1', rel: '0', playsinline: '1' });
    frame.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?' + params;
    frame.title = button.getAttribute('aria-label') || 'Video';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    frame.setAttribute('frameborder', '0');
    button.replaceWith(frame);
    frame.focus();
  });

  /* A missing maxresdefault is answered with a 120x90 grey card and HTTP 200, so
     there is no error event for that case — only for a genuine network failure.
     Both are handled: the listener catches the failure, and the size check below
     catches the grey card once the image has decoded. Capture phase, because
     `error` on an <img> does not bubble. */
  const swapPoster = (img) => {
    const button = img.closest('.dm-pv__play');
    const fallback = button && button.getAttribute('data-dm-fallback');
    if (!fallback || img.dataset.dmSwapped) return;
    img.dataset.dmSwapped = '1';
    img.src = fallback;
  };

  document.addEventListener(
    'error',
    (event) => {
      const img = event.target;
      if (img instanceof HTMLImageElement && img.classList.contains('dm-pv__poster')) swapPoster(img);
    },
    true
  );

  document.addEventListener(
    'load',
    (event) => {
      const img = event.target;
      if (!(img instanceof HTMLImageElement) || !img.classList.contains('dm-pv__poster')) return;
      if (img.naturalWidth <= 120 && img.naturalHeight <= 90) swapPoster(img);
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
